<div class="match-container">
  <div class="match-flex-grid">
    <div class="match-flex-item" style="text-align: center">
      <img src="{{extracted}}" alt="" class="match-img" (click)="showLarge(extracted)">
    </div>
  </div>
</div>
